import classNames from 'classnames';

import { BaseLayout } from '@layouts/BaseLayout';
import { HeaderSimple } from '@components/HeaderSimple';
import { useBasket } from '@hook/useBasket';
import { CartModal } from '@components/CartModal';

import s from './SimpleLayout.sss';

type SimpleLayoutProps = {
  layoutClassName?: string
  className?: string;
  isLinkifyLogo?: boolean;
};

export const SimpleLayout: React.FC<React.PropsWithChildren<SimpleLayoutProps>> = ({
  layoutClassName,
  className,
  isLinkifyLogo,
  children,
}) => {
  const { ui: basketUI } = useBasket({ lazy: true });

  return (
    <BaseLayout className={classNames(s.root, layoutClassName)}>
      <HeaderSimple
        className={s.header}
        isLinkifyLogo={isLinkifyLogo}
      />
      <main className={classNames(s.main, className)}>
        {children}
      </main>

      <CartModal
        isOpen={basketUI.isOpen}
        onRequestClose={basketUI.close}
      />
    </BaseLayout>
  );
};
